<template>
  <div class="blogpost-list">
    <Header title="BLOG"></Header>
    <div class="container">
      <div class="blogpost-listing">
        <BlogpostCard :blogpost="blogpost" v-for="blogpost in blogposts" :key="blogpost.id"></BlogpostCard>
      </div>
    </div>
  </div>
</template>

<script>
import BlogpostCard from "@/components/BlogpostCard";
import Header from "@/components/Header";
export default {
  name: "BlogpostList",
  metaInfo: {
    title: "Blog - Novidades do QUEOTA"
  },
  data() {
    return {
      blogposts: []
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("blog.json")
        .then(response => (this.blogposts = response.data));
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    BlogpostCard,
    Header
  }
};
</script>

<style lang="sass">
.blogpost-page
  // background: #efefef
  .blogpost-listing
    display: flex
    flex-wrap: wrap
    // justify-content: space-around
    a.blogpost-card
      max-width: 350px
      margin-bottom: 20px
      margin-right: 10px
      // h4
      //   color: #333
      // p.preview-content
      //   color: #333
      // span.time
      //   color: #333
</style>
